export function getToday(){
    const temToday = new Date();
    const year = temToday.getFullYear();
    let month = temToday.getMonth()+1;
    let date = temToday.getDate();

    if(month<10) month = `0${month}`;
    if(date<10) month = `0${month}`;

    return(`${year}-${month}-${date}`)
}